/**
 * Parse map coordinates from an event API payload.
 * Returns finite numbers or null when coords are missing/invalid.
 */
export function parseEventCoordinates(event) {
  if (!event) {
    return { latitude: null, longitude: null };
  }

  const latitude = Number(event.latitude);
  const longitude = Number(event.longitude);

  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    return { latitude, longitude };
  }

  return { latitude: null, longitude: null };
}

export function hasEventCoordinates({ latitude, longitude } = {}) {
  return latitude != null && longitude != null;
}
